import React from 'react';
import { useState, useEffect } from 'react';

import { Link, useHistory } from 'react-router-dom';
import Header from '../../../../components/Elements/header/header';
import EDSFooter from '../../../../components/EDSFooter';
import StepsOfBuy from '../../../summary/navigatorBarSummary/stepsOfBuy/stepsOfBuy';
import Modal from '../../../../components/Elements/modal/modal';
import './register.css';
import RemiandPassword from '../../remiandPassword/remiandPassword';
import CustomTittle from '../../../../components/Elements/customTittle/customTittle';
import CustomButtons from '../../../../components/Elements/Buttons/customButton';
import CourseDetail from '../../../coursDetail/courseDetail';
import CustomInput from '../../../../components/Elements/input/customInput';
import CustomRedText from '../../../../components/Elements/redText/redText';
import AcceptInput from '../../../chooseUserBuy/accept/accept';
import CustomLink from '../../../../components/Elements/Link/link';
import ChooseUserOption from '../../../chooseUserBuy/chooseUser/chooseUserOption/chooseUserOption';
import { useSelector } from 'react-redux';
import ApiService from '../../../../services/ApiService';
import CustomUnderlineText from '../../../../components/Elements/underlineText/underlineText';
import Statue from "./statue.js"
import RodoInfo from "./rodoForAccept.js"
import { API_URL, API_URL_getCourseWWWInfoPortal } from '../../../../config';
const Register = (props) => {
    const apiService = ApiService.getInstance();
    const isKey = localStorage.getItem('keyURL');
    const departure = localStorage.getItem('departure')
    const [header, setHeader] = useState('/  PROCES ZAKUPU KURSU');
    const [correctResponse, setCorrectResponse] = useState(false);
    let localizationName = localStorage.getItem('localizationName');
    const stepsIndex = 0;
    var currentLocation = window.location.href;
    const history = useHistory();
    let today = new Date();
    let day = today.getDate();
    let month = today.getMonth() + 1;
    let year = today.getFullYear();
    if (month < 10) {
        month = '0' + month;
    }
    const startDate = `${year}-${month}-${day}`;
    let  key =  useSelector((state) => state.repos.chName);
    if(key&&key.includes("%20")){
        key =  key.replaceAll("%20", " ")
    }
    if(currentLocation.includes("key=")){
        if(currentLocation.includes("departure")){

        }else{
       
        key= currentLocation.split("/")[3].split("?")[0].replace("key=", "")
        if(key.includes("%20")){
            key =  key.replaceAll("%20", " ")
        }
    }}
  
    var currentLocation = window.location.href.split("/");
    let [modalClass, showModal] = useState('modal hidden');
    let [isYoung, setYoung] = useState(false);
    let [part, changePart] = useState({
        number: 0,
        msg: 'Na twoją skrzynkę mailową wysłaliśmy link aktywacyjny do Twojego konta.',
        tittle: 'DZIĘKUJEMY ZA ZAREJESTROWANIE KONTA!',
    });
    function showCalendary(e){
      
        document.getElementById("calendary").showPicker();
    }

    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        // genderDVID: 0,
        // dateofbirdth: '',
        // pesel: '',
        // street: '',
        // building: '',
        // flat: '',
        // city: '',
        // postalCode: '',
        email: '',
        phone: '',
        personalDataProcessingConsent: 0,
        currentPurchaseKey: key,
        currentDeparture: departure,
        isAdult: true
     
    });

    const [formDataValidation, setFormDataValidation] = useState({
        firstName: true,
        lastName: true,
        // dateofbirdth: true,
        // pesel: true,
        // street: true,
        // building: true,
        // genderDVID: true,
        // city: true,
        // postalCode: true,
        email: true,
        phone: true,
        personalDataProcessingConsent: true,
        statuteDataProcessingConsent: false,
    });
let [formDataForEmail, setFormDataForEmail] = useState({
    email: "",
    personalDataProcessingConsent: 0,
    statuteDataProcessingConsent: false,
}) 

const [consentValidation, setConsentValidation] = useState({
    personalDataProcessingConsent: false,
    statuteDataProcessingConsent: false,
})


    function changeModal() {
        if (modalClass == 'modal hidden') {
            showModal('modal');
        } else {
            showModal('modal hidden');
        }
    }

    const stepsList = ['Rejestracja', 'Kurs i formalności', 'Podsumowanie'];

    function nextPage() {}
    function backToLogin() {
        if(key){
            history.push('/LoginBuy/key=' + key);
        }else{
            history.push('/LoginBuy');
        }
        
    }

    const getEmail = async () => {
       
            if (
            formData.email != '' &&
            formData.personalDataProcessingConsent != 0 &&
            formDataValidation.statuteDataProcessingConsent != undefined
        ) {
           
            let timeStemp = new Date().valueOf();
            let salesmanagoData = {
                clientId: '6d4952a5969ba98b',
                apiKey: 'OU6EB2LLPYCxOEi1B7jj',
                requestTime: timeStemp,
                sha: 'f5abf2aed8f32be5d48d8e8b8c9024891ed92e92',
                owner: 'dorot30@matchmatepro.com',
                contact: {
                    email: formData.email,
                },
            };

            // await fetch("https://app2.salesmanago.pl/api/contact/upsert",{
            //     method: "POST",
            //     headers: {
            //         "Accept": "application/json",
            //         "Content-Type": "application/json;charset=UTF-8"},
            //       body: JSON.stringify(salesmanagoData),
            // })
            //dorot30@matchmatepro.com
            await apiService
                .asyncApiPost('UserRegistrationInfo', { email: formData.email,  currentPurchaseKey:key}, false)
                .then((response) => {
                    if (response.succeeded) {
                        changePart({ ...part, number: 1 });
                    }
                });

            document.querySelector('input').value = '';
        } else {
            
            if (formData.email == '') {
              
                formDataValidation.email = false;
            }else{
                formDataValidation.email = true
            }
            if (formData.personalDataProcessingConsent == 0) {
                setFormDataValidation({
                    ...formDataValidation,
                    ...{ personalDataProcessingConsent: false },
                });
                setConsentValidation({statuteDataProcessingConsent:true,
                    personalDataProcessingConsent:true
                })
            }
            // if (formDataValidation.statuteDataProcessingConsent == null) {
            //     setFormDataValidation({
            //         ...formDataValidation,
            //         ...{ statuteDataProcessingConsent: false },
            //     });
            // }
        }
    };
    function moveToRodo(){
        const win = window.open("/RODO", "_blank");
  win.focus();
       
    }
    function register() {
        

         
              
        if (
            formData.firstName != '' &&
            formData.lastName != '' &&
            // formData.dateofbirdth != '' &&
            // formDataValidation.pesel &&
            // formData.street != '' &&
            // formData.building != '' &&
            // formData.genderDVID != 0 &&
            // formData.city != '' &&
            // formData.postalCode != '' &&
            formData.email != '' &&
            formDataValidation.phone &&
            formData.personalDataProcessingConsent != 0
        ) {
            

            apiService.apiPost(
                'CheckUserForRegistrationStatus',
                formData,
                (response) => {
                    



                    // RegistrationStatus = -5,  Message= "strErrorOnUserRegistration" -> błąd techniczny przy dodawaniu do bazy


                    // RegistrationStatus = -3,  Message = "strErrorOnLoginUpdate" -> błąd techniczny przy update

                 

                    // RegistrationStatus = -5, Message = "strErrorOnUserRegistration" -> techniczny Exception, cos u nas poszło nie tak -> BOK albo coś co teraz już było

                    if (response.success) {
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                        'event' : 'sign_up'
                        });
                        if (response.data.message == 'strActiveUser') {
                            changePart({
                                number: 3,
                                msg: 'Podany adres e-mail jest już zarejestrowany',
                                tittle: 'Podany adres e-mail jest już zarejestrowany. Zaloguj się do konta. Jeśli nie pamiętasz hasła, skorzystaj z opcji "Przypomnij hasło"',
                            });
                        } else if(response.data.message == 'strUserRegistered'||response.message == 'OK') {
                           

                            changePart({ ...part, number: 2 });
                        }else if(response.data.message == 'strInactiveUser') {
                            changePart({
                                number: 3,
                                msg: 'Podany adres e-mail jest już zarejestrowany',
                                tittle: 'Aktywuj swoje konto',
                            });
                        }else if(response.data.message == 'strLoginUpdated') {
                            changePart({
                                number: 3,
                                tittle: 'Konto z takimi danymi jest już w sytemie',
                                msg: 'Zaktualizowaliśmy twoje dane. Link do resetu hasła został wysłany na twój adres E-mail.',
                            });
                        }
                        else if(response.data.message == 'strAnotherUserWithEmailOrPesel') {
                            changePart({
                                number: 3,
                                tittle: 'Na podane dane został już zarejestrowany użytkownik',
                                msg: 'Twój adres e-mail znajduje się już w systemie, aby odzyskać hasło skontaktuj się z nami pod adresem studio@egurrola.com lub kliknij w przycisk',
                            });
                        }
                        else {
                            changePart({
                                number: 2,
                                tittle: 'Nie udało się zarejestrować nowego konta!',
                                msg: 'Skontaktuj się z biurem obsługi klienta',
                            });
                        }
                    } else {
                        changePart({
                            number: 2,
                            tittle: 'Nie udało się zarejestrować nowego konta!',
                            msg: 'Skontaktuj się z biurem obsługi klienta',
                        });
                    }
                },
                false
            );
       
        } else {
            setFormDataValidation({
                firstName: !formData.firstName == '',
                lastName: !formData.lastName == '',
                // dateofbirdth: !formData.dateofbirdth == '',
                // pesel: !formData.pesel == '',
                // street: !formData.street == '',
                // building: !formData.building == '',
                // genderDVID: !formData.genderDVID == 0,
                // city: !formData.city == '',
                // postalCode: !formData.postalCode == '',
                email: !formData.email == '',
                phone: !formData.phone == '',
                personalDataProcessingConsent: !formData.personalDataProcessingConsent == 0,
                statuteDataProcessingConsent: formDataValidation.statuteDataProcessingConsent,
            })
            if (formData.firstName == '') {
                formDataValidation.firstName = false;
            }
            if (formData.lastName == '') {
                formDataValidation.lastName = false;
            }
            // if (formData.dateofbirdth == '') {
            //     formDataValidation.dateofbirdth = false;
            // }
            // if (formData.genderDVID == 0) {
            //     formDataValidation.genderDVID = false;
            // }
            // if (formData.pesel == '') {
            //     formDataValidation.pesel = false;
            // }
            // if (formData.street == '') {
            //     formDataValidation.street = false;
            // }
            // if (formData.building == '') {
            //     formDataValidation.building = false;
            // }
            // if (formData.city == '') {
            //     formDataValidation.city = false;
            // }
            // if (formData.postalCode == '') {
            //     formDataValidation.postalCode = false;
            // }
            if (formData.email == '') {
                formDataValidation.email = false;
            }

            if (formData.phone == '') {
                formDataValidation.phone = false;
            }
            if (formData.personalDataProcessingConsent == 0) {
                formDataValidation.personalDataProcessingConsent = false;
            }
        }
    }
    function reportWindowSize() {
  
   if(currentLocation.includes("Statue")){
    
    if (window.innerWidth > 951) {
        setHeader('/  Regulamin Egurrola Dance Studio');
    } else {
        setHeader('/  Regulamin');
    }
   }else if(currentLocation.includes("RODO")){
    setHeader('/  RODO');
   }
   else{
    
        if(localStorage.getItem('keyURL') != ""&&localStorage.getItem('keyURL') != undefined){
            if (window.innerWidth > 951) {
                setHeader('/  PROCES ZAKUPU KURSU');
            } else {
                setHeader('/  ZAKUP KURSU');
            }}else{
                setHeader('');
            }}
    }
    function PeselDecode(pesel) {
        
        var rok = parseInt(pesel.substring(0, 2), 10);
        var miesiac = parseInt(pesel.substring(2, 4), 10);
        var dzien = parseInt(pesel.substring(4, 6), 10);

        if (miesiac > 80) {
            rok = rok + 1800;
            miesiac = miesiac - 80;
        } else if (miesiac > 60) {
            rok = rok + 2200;
            miesiac = miesiac - 60;
        } else if (miesiac > 40) {
            rok = rok + 2100;
            miesiac = miesiac - 40;
        } else if (miesiac > 20) {
            rok = rok + 2000;
            miesiac = miesiac - 20;
        } else {
            rok += 1900;
        }
        // Daty sa ok. Teraz ustawiamy.
        if(miesiac < 10){
            miesiac = "0" + miesiac 
        }
        if(dzien < 10){
            dzien = "0" + dzien
        }
        var urodzony = rok + '-' + miesiac + '-' + dzien;
   
        if(urodzony != null){
        document.getElementById("calendary").value = urodzony}
        return urodzony
       
   
    }
    // useEffect(() => {

        
    // }, []);


    useEffect(() => {
        reportWindowSize();
     
        if (window.location.href.includes("key=")) {
            
            let urlApi = `${API_URL_getCourseWWWInfoPortal}getCourseWWWInfoPortal`
            localStorage.setItem("keyURL",key )
            let jsonBody = {
                courseHeadingName: key, // 'Żwiry-K1', // TODO będzie przychodić w linku w gecie
        attendanceStartDate: `${startDate}`,
        current_LocalizationsID: '0',
            };
            
                console.log(urlApi);
            fetch(
                `${urlApi}`,
                {
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        Authorization: null,
                    },
                    body: JSON.stringify(jsonBody),
                }
            )
                .then((response) => {
                  
                    return response.json();
                })
                .then((response) => {
            // if(departureName == ""){
         

                
                    localStorage.setItem('courseHeadingFull', JSON.stringify(response.body));
                    localStorage.setItem('danceStyle', response.body.courseDanceStyle);
                    localStorage.setItem('courseTime', response.body.courseTime);
                    localStorage.setItem('frequency', response.body.Frequency);
                    localStorage.setItem('courseLevel', response.body.courseLevel);
                    localStorage.setItem('courseAgeRanges', response.body.courseAgeRanges);
                    localStorage.setItem('localizationName', response.body.localizationName);
                    localStorage.setItem('instructorsList', response.body.instructorsList);
                    localStorage.setItem('localizationName', response.body.localizationName);
                    localStorage.setItem('eventDate', response.body.eventDate);
                    localStorage.removeItem('campHeadingFull');
                    setCorrectResponse(true)
                //    }else{
                //         localStorage.removeItem('courseHeadingFull');
                //         localStorage.setItem('campHeadingFull', JSON.stringify(response.responseBody.body));
          
                //     }
                setCorrectResponse(true)
                });
        } else {
           
if(key == undefined&&!currentLocation.includes('Statue')&&!currentLocation.includes('RODO')){
            localStorage.removeItem('courseHeadingFull');
            localStorage.removeItem('campHeadingFull');
            localStorage.removeItem('danceStyle');
            localStorage.removeItem('courseTime');
            localStorage.removeItem('frequency');
            localStorage.removeItem('courseLevel');
            localStorage.removeItem('courseAgeRanges');
            localStorage.removeItem('localizationName');
            localStorage.removeItem('instructorsList');
   
            localStorage.removeItem('eventDate');
           }
        }
        document.getElementById('registerEmail')?.getElementsByClassName('input_withTittle ')[0].addEventListener('keypress', function (e) {     
            
            if (e.key === 'Enter') {
                
                e.preventDefault()
                 getEmail(formData);
            }
        });
      
    }, []);
    useEffect(() => {

        let inputsList = document.getElementById('registerPart2')?.getElementsByTagName("input");

        for(var i = 0; i < inputsList?.length;i++){
            inputsList[i].addEventListener('keypress', function (e) {     
                if (e.key === 'Enter') {
                    
                    register();
                }
            });
        }

    }, [part.number]);

    window.onresize = reportWindowSize;

    return (
        <>
            <div className={modalClass}>
                <Modal close={changeModal}>
                <RemiandPassword modalState={modalClass} closeModal={changeModal}></RemiandPassword>
                </Modal>
            </div>
            <Header>{header}</Header>
            {currentLocation.includes("Statue")?
            <Statue localizationName={localizationName}></Statue>
            :currentLocation.includes("RODO")?<RodoInfo localizationName={localizationName}></RodoInfo>:<div className="content">
                
            {localStorage.getItem('keyURL') != ""&&localStorage.getItem('keyURL') != undefined ?<StepsOfBuy choosen={stepsIndex} stepsList={stepsList}></StepsOfBuy>:""}
            <div className="rowSectionReg">
                <div className="columnLogin" >
                    {part.number == 0 ? (
                        <div className="columnLogin_wrapper" id="registerEmail">
                            <div className="Register_headLine">
                                
                                <CustomRedText>Krok 1/2</CustomRedText>
                            </div>
                            <CustomInput
                                onChangeInput={(e) => {
                                    if (!formDataValidation['email']) {
                                        setFormDataValidation({
                                            ...formDataValidation,
                                            ...{ email: true },
                                        });
                                    }
                                    let value = e.replaceAll(' ', '');
                                    const regexExp =
                                        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/gi;

                                    if (regexExp.test(value)) {
                                        setFormDataForEmail({...formDataForEmail,
                                            ...{ email: value },})
                                        setFormData({
                                            ...formData,
                                            ...{ email: value },
                                        });
                                    } else {
                                        
                                        setFormDataValidation({
                                            ...formDataValidation,
                                            ...{ email: false },
                                        });
                                        setFormData({
                                            ...formData,
                                            ...{ email: "" },
                                        });
                                    }
                                }}
                                title="E-mail"
                                validation={formDataValidation['email']}
                                showCalendary={() => {
                                    if (!formDataValidation['email']) {
                                        setFormDataValidation({
                                            ...formDataValidation,
                                            ...{ email: true },
                                        });
                                    }
                                }}
                                isRequied={true}
                                size="big"
                            ></CustomInput>
                            {/* <CustomInput 
            title="Hasło" isRequied={true}  size="big"></CustomInput>
            <CustomInput  title="Powtórz hasło" isRequied={true}  size="big"></CustomInput> */}
                            <div className="consent_accept">
                                <CustomTittle size="medium">Zaakceptuj zgody</CustomTittle>
                                {consentValidation.personalDataProcessingConsent||consentValidation.statuteDataProcessingConsent? 
                                       
                                        <div className="errorMsg">
                                            <p>Zaakceptuj wymagane zgody</p>{' '}
                                            <p className="hintTextDot">!</p>{' '}
                                        </div>:""
                                     
                                    
                                }
                                <div className="acceptSection">
                                    <div className="labelDiv">
                                        <AcceptInput
                                            onAccept={(e) => {
                                                
                                                if (e) {
                                                    setFormDataForEmail({...formDataForEmail,
                                                        ...{ personalDataProcessingConsent: 0 },})
                                                    setFormData({
                                                        ...formData,
                                                        ...{ personalDataProcessingConsent: 0 },
                                                    });
                                                    setConsentValidation({...consentValidation,
                                                        personalDataProcessingConsent:true
                                                    })
                                                } else {
                                                    setFormDataForEmail({...formDataForEmail,
                                                        ...{ personalDataProcessingConsent: 1 },})
                                                    setFormData({
                                                        ...formData,
                                                        ...{ personalDataProcessingConsent: 1 },
                                                    });
                                                    setConsentValidation({...consentValidation,
                                                        personalDataProcessingConsent:false
                                                    })
                                                }
                                            }}
                                            label="Akceptuję klauzulę informacyjną RODO"
                                        />
                                        <p className="hintTextDot" onClick={moveToRodo}>?</p>
                                    </div>
                                    <div className="labelDiv">
                                        <AcceptInput
                                            onAccept={(e) => {
                                                
                                                if (e) {
                                                    setFormDataForEmail({...formDataForEmail,
                                                        ...{ statuteDataProcessingConsent: false },})
                                                    setFormDataValidation({
                                                        ...formDataValidation,
                                                        ...{ statuteDataProcessingConsent: false },
                                                    });
                                                    setConsentValidation({...consentValidation,
                                                        statuteDataProcessingConsent:true
                                                    })
                                                } else {
                                                    setFormDataForEmail({...formDataForEmail,
                                                        ...{ statuteDataProcessingConsent: true },})
                                                    setFormDataValidation({
                                                        ...formDataValidation,
                                                        ...{ statuteDataProcessingConsent: true },
                                                    });
                                                    setConsentValidation({...consentValidation,
                                                        statuteDataProcessingConsent:false
                                                    })
                                                }
                                            }}
                                            label="Akceptuję"
                                        />
                                        <CustomLink link="/Statue">Regulamin</CustomLink>
                                    </div>
                                </div>
                            </div>
                            <div className="button_section">
                                <CustomButtons
                                    clickFunction={getEmail}
                                    classButton="solid"
                                    size="big"
                                >
                                    PRZEJDŹ DALEJ
                                </CustomButtons>
                                <p>lub</p>
                                <CustomButtons
                                    clickFunction={backToLogin}
                                    classButton="outline"
                                    size="big"
                                >
                                    ZALOGUJ SIĘ
                                </CustomButtons>
                            </div>
                        </div>
                    ) : (
                        ''
                    )}
                    {part.number == 1 ? (
                        <div className="columnLogin_wrapper" id="registerPart2">
                            <div className="Register_headLine">
                                <CustomTittle>Podaj swoje dane</CustomTittle>
                                <CustomRedText>Krok 2/2</CustomRedText>
                                </div>
                            <div className="chooseConection">
                            <CustomInput
                                validation={formDataValidation['firstName']}
                                showCalendary={() => {
                                    if (!formDataValidation['firstName']) {
                                        setFormDataValidation({
                                            ...formDataValidation,
                                            ...{ firstName: true },
                                        });
                                    }
                                }}
                                onChangeInput={(e) => {
                                    let value = e.trim();
                                    if (value.length != 0) {
                                        if (!formDataValidation['firstName']) {
                                            setFormDataValidation({
                                                ...formDataValidation,
                                                ...{ firstName: true },
                                            });
                                        }
                                        setFormData({
                                            ...formData,
                                            ...{ firstName: value },
                                        });
                                    } else {
                                        setFormDataValidation({
                                            ...formDataValidation,
                                            ...{ firstName: false },
                                        });
                                        setFormData({
                                            ...formData,
                                            ...{ firstName: "" },})
                                    }
                                }}
                                title="Imię"
                                isRequied={true}
                                size="big"
                            ></CustomInput>
                            <CustomInput
                                validation={formDataValidation['lastName']}
                                showCalendary={() => {
                                    if (!formDataValidation['lastName']) {
                                        setFormDataValidation({
                                            ...formDataValidation,
                                            ...{ lastName: true },
                                        });
                                    }
                                }}
                                onChangeInput={(e) => {
                                    let value = e.trim();
                                    if (value.length != 0) {
                                        if (!formDataValidation['lastName']) {
                                            setFormDataValidation({
                                                ...formDataValidation,
                                                ...{ lastName: true },
                                            });
                                        }
                                        setFormData({
                                            ...formData,
                                            ...{ lastName: value },
                                        });
                                    } else {
                                        setFormDataValidation({
                                            ...formDataValidation,
                                            ...{ lastName: false },
                                        });
                                        setFormData({
                                            ...formData,
                                            ...{ lastName: "" },
                                        });
                                    }
                                }}
                                title="Nazwisko"
                                isRequied={true}
                                size="big"
                            ></CustomInput>
                            </div>
                            {/* <div className="chooseConection">
                                <p>Płeć</p>
                                <ChooseUserOption
                                    isChekcked={formData.genderDVID == 2}
                                    onCheck={(e) => {
                                        formDataValidation.genderDVID = true
                                        setFormData({
                                            ...formData,
                                            ...{ genderDVID: 2 },
                                        });
                                    }}
                                    label="Kobieta"
                                ></ChooseUserOption>
                                <ChooseUserOption
                                    isChekcked={formData.genderDVID == 1}
                                    onCheck={(e) => {
                                        formDataValidation.genderDVID = true
                                        setFormData({
                                            ...formData,
                                            ...{ genderDVID: 1 },
                                        });
                                    }}
                                    label="Mężczyzna"
                                ></ChooseUserOption>
                                <ChooseUserOption
                                    isChekcked={formData.genderDVID == 3}
                                    onCheck={(e) => {
                                        formDataValidation.genderDVID = true
                                        setFormData({
                                            ...formData,
                                            ...{ genderDVID: 3 },
                                        });
                                    }}
                                    label="Nie chcę podawać"
                                ></ChooseUserOption>
                                {!formDataValidation.genderDVID?<p className="msgInvalid">*Uzupełnij wymagane pole</p>:""}
                            </div> */}
                            {/* <div className="chooseConection"> */}
                                {/* <CustomInput
                                id="calendary2"
                                    validation={formDataValidation['pesel']}
                                    showCalendary={() => {
                                        if (!formDataValidation['pesel']) {
                                            setFormDataValidation({
                                                ...formDataValidation,
                                                ...{ pesel: true },
                                            });
                                        }
                                    }}
                                    isRequied={true}
                                    title="Pesel"
                                    onChangeInput={(e) => {
                                        let value = e.replaceAll(' ', '');
                                      
                                        if (/^\d+$/.test(value) && value.length == 11) {
                                            let weight = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
                                            let sum = 0;
                                            let controlNumber = parseInt(value.substring(10, 11));
                                        
                                            for (let i = 0; i < weight.length; i++) {
                                                sum += (parseInt(value.substring(i, i + 1)) * weight[i]);
                                            }
                                            sum = sum % 10;
                                            let isCorrect =  (10 - sum) % 10 === controlNumber;
                                            if(isCorrect)
                                            {let bd = PeselDecode(value)
                                            if (!formDataValidation['pesel']) {
                                                setFormDataValidation({
                                                    ...formDataValidation,
                                                    ...{ pesel: true, dateofbirdth: true  },
                                                });
                                            }
                                          
                                           
                                            setFormData({
                                                ...formData,
                                                ...{ pesel: parseInt(value), dateofbirdth: bd  },
                                            });}else {
                                                setFormDataValidation({
                                                    ...formDataValidation,
                                                    ...{ pesel: false },
                                                });
                                                setFormData({
                                                    ...formData,
                                                    ...{ pesel: "", dateofbirdth: "" },
                                                });
                                            }
                                        } else {
                                            setFormDataValidation({
                                                ...formDataValidation,
                                                ...{ pesel: false },
                                            });
                                            setFormData({
                                                ...formData,
                                                ...{ pesel: "", dateofbirdth: "" },
                                            });
                                        }
                                    }}
                                ></CustomInput>
                                <CustomInput
                                    id="calendary"
                                    icon={<svg onClick={showCalendary} width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.06847 13.9347H4.99777C4.52668 13.9347 4.14983 14.3115 4.14983 14.7826V14.8768C4.14983 15.3479 4.52668 15.7248 4.99777 15.7248H5.06847C5.53956 15.7248 5.91641 15.3479 5.91641 14.8768V14.7826C5.91641 14.3115 5.53956 13.9347 5.06847 13.9347Z" fill="#CC0033"/>
                                    <path d="M8.50746 13.9347H8.43677C7.96567 13.9347 7.58882 14.3115 7.58882 14.7826V14.8768C7.58882 15.3479 7.96567 15.7248 8.43677 15.7248H8.50746C8.97855 15.7248 9.35541 15.3479 9.35541 14.8768V14.7826C9.35541 14.3115 8.97855 13.9347 8.50746 13.9347Z" fill="#CC0033"/>
                                    <path d="M11.97 13.9347H11.8758C11.4047 13.9347 11.0278 14.3115 11.0278 14.7826V14.8768C11.0278 15.3479 11.4047 15.7248 11.8758 15.7248H11.97C12.4411 15.7248 12.8179 15.3479 12.8179 14.8768L12.818 14.7826C12.818 14.3115 12.4411 13.9347 11.97 13.9347Z" fill="#CC0033"/>
                                    <path d="M5.06847 10.4486H4.99777C4.52668 10.4486 4.14983 10.8254 4.14983 11.2965V11.3907C4.14983 11.8618 4.52668 12.2387 4.99777 12.2387H5.06847C5.53956 12.2387 5.91641 11.8618 5.91641 11.3907V11.2965C5.91641 10.8254 5.53956 10.4486 5.06847 10.4486Z" fill="#CC0033"/>
                                    <path d="M8.50746 10.4486H8.43677C7.96567 10.4486 7.58882 10.8254 7.58882 11.2965V11.3907C7.58882 11.8618 7.96567 12.2387 8.43677 12.2387H8.50746C8.97855 12.2387 9.35541 11.8618 9.35541 11.3907V11.2965C9.35541 10.8254 8.97855 10.4486 8.50746 10.4486Z" fill="#CC0033"/>
                                    <path d="M11.97 10.4486H11.8758C11.4047 10.4486 11.0278 10.8254 11.0278 11.2965V11.3907C11.0278 11.8618 11.4047 12.2387 11.8758 12.2387H11.97C12.4411 12.2387 12.8179 11.8618 12.8179 11.3907V11.2965C12.818 10.8254 12.4411 10.4486 11.97 10.4486Z" fill="#CC0033"/>
                                    <path d="M15.4089 13.9347H15.3147C14.8436 13.9347 14.4668 14.3115 14.4668 14.7826V14.8768C14.4668 15.3479 14.8436 15.7248 15.3147 15.7248H15.4089C15.88 15.7248 16.2569 15.3479 16.2569 14.8768V14.7826C16.2804 14.3115 15.88 13.9347 15.4089 13.9347Z" fill="#CC0033"/>
                                    <path d="M18.8714 13.9347H18.7772C18.3061 13.9347 17.9293 14.3115 17.9293 14.7826V14.8768C17.9293 15.3479 18.3061 15.7248 18.7772 15.7248H18.8714C19.3425 15.7248 19.7194 15.3479 19.7194 14.8768V14.7826C19.7194 14.3115 19.3425 13.9347 18.8714 13.9347Z" fill="#CC0033"/>
                                    <path d="M15.4089 10.4486H15.3147C14.8436 10.4486 14.4668 10.8254 14.4668 11.2965V11.3907C14.4668 11.8618 14.8436 12.2387 15.3147 12.2387H15.4089C15.88 12.2387 16.2569 11.8618 16.2569 11.3907V11.2965C16.2804 10.8254 15.88 10.4486 15.4089 10.4486Z" fill="#CC0033"/>
                                    <path d="M18.8714 10.4486H18.7772C18.3061 10.4486 17.9293 10.8254 17.9293 11.2965V11.3907C17.9293 11.8618 18.3061 12.2387 18.7772 12.2387H18.8714C19.3425 12.2387 19.7194 11.8618 19.7194 11.3907V11.2965C19.7194 10.8254 19.3425 10.4486 18.8714 10.4486Z" fill="#CC0033"/>
                                    <path d="M5.06847 17.3972H4.99777C4.52668 17.3972 4.14983 17.774 4.14983 18.2451V18.3393C4.14983 18.8104 4.52668 19.1873 4.99777 19.1873H5.06847C5.53956 19.1873 5.91641 18.8104 5.91641 18.3393V18.2451C5.91641 17.7976 5.53956 17.3972 5.06847 17.3972Z" fill="#CC0033"/>
                                    <path d="M8.50746 17.3972H8.43677C7.96567 17.3972 7.58882 17.774 7.58882 18.2451V18.3393C7.58882 18.8104 7.96567 19.1873 8.43677 19.1873H8.50746C8.97855 19.1873 9.35541 18.8104 9.35541 18.3393V18.2451C9.35541 17.7976 8.97855 17.3972 8.50746 17.3972Z" fill="#CC0033"/>
                                    <path d="M11.97 17.3972H11.8758C11.4047 17.3972 11.0278 17.774 11.0278 18.2451V18.3393C11.0278 18.8104 11.4047 19.1873 11.8758 19.1873H11.97C12.4411 19.1873 12.8179 18.8104 12.8179 18.3393V18.2451C12.818 17.7976 12.4411 17.3972 11.97 17.3972Z" fill="#CC0033"/>
                                    <path d="M15.4089 17.3972H15.3147C14.8436 17.3972 14.4668 17.774 14.4668 18.2451V18.3393C14.4668 18.8104 14.8436 19.1873 15.3147 19.1873H15.4089C15.88 19.1873 16.2569 18.8104 16.2569 18.3393V18.2451C16.2804 17.7976 15.88 17.3972 15.4089 17.3972Z" fill="#CC0033"/>
                                    <path d="M18.8714 17.3972H18.7772C18.3061 17.3972 17.9293 17.774 17.9293 18.2451V18.3393C17.9293 18.8104 18.3061 19.1873 18.7772 19.1873H18.8714C19.3425 19.1873 19.7194 18.8104 19.7194 18.3393V18.2451C19.7194 17.7976 19.3425 17.3972 18.8714 17.3972Z" fill="#CC0033"/>
                                    <path d="M23.1113 7.69266V5.78476C23.1113 4.32441 21.9336 3.14664 20.4967 3.14664H19.107V2.32224C19.107 1.30935 18.2826 0.48494 17.2697 0.48494C16.2568 0.48494 15.4324 1.30935 15.4324 2.32224V3.14664L8.46025 3.14657V2.32216C8.46025 1.30927 7.63584 0.484863 6.62296 0.484863C5.61007 0.484863 4.78566 1.30927 4.78566 2.32216V3.14657H3.39592C1.93558 3.14657 0.757812 4.3243 0.757812 5.78468V19.8703C0.757812 21.3071 1.93554 22.4849 3.39592 22.4849H20.5201C21.9569 22.4849 23.1346 21.3071 23.1346 19.8703L23.1113 7.69266ZM16.516 2.32222C16.516 1.92183 16.8458 1.59204 17.2462 1.59204C17.6466 1.59204 17.9764 1.92183 17.9764 2.32222V4.06527C17.9764 4.46566 17.6466 4.79544 17.2462 4.79544C16.8458 4.79544 16.516 4.46566 16.516 4.06527V2.32222ZM5.86935 2.32222C5.86935 1.92183 6.19913 1.59204 6.59952 1.59204C6.99991 1.59204 7.32969 1.92183 7.32969 2.32222V4.06527C7.32969 4.46566 6.99991 4.79544 6.59952 4.79544C6.19913 4.79544 5.86935 4.46566 5.86935 4.06527V2.32222ZM3.37256 4.25373H4.78584C4.88007 5.17238 5.65732 5.90255 6.62313 5.90255C7.56532 5.90255 8.34266 5.17238 8.4368 4.25373H15.4325C15.5267 5.17238 16.304 5.90255 17.2462 5.90255C18.1883 5.90255 18.9657 5.17238 19.0598 4.25373H20.4731C21.2975 4.25373 21.9806 4.93683 21.9806 5.78477V7.15098L1.84146 7.1509V5.7847C1.84146 4.93675 2.52462 4.25373 3.37256 4.25373ZM20.4967 21.3779H3.37256C2.52462 21.3779 1.84152 20.6948 1.84152 19.8704V8.23443H22.0042V19.8704C22.0043 20.6948 21.3211 21.3779 20.4967 21.3779Z" fill="#CC0033"/>
                                    </svg>
                                    }
                                    validation={formDataValidation['dateofbirdth']}
                                    showCalendary={(e) => {
                                        e.target.showPicker();
                                        if (!formDataValidation['dateofbirdth']) {
                                            setFormDataValidation({
                                                ...formDataValidation,
                                                ...{ dateofbirdth: true },
                                            });
                                        }
                                    }}
                                    pattern="dd.mm.rrrr"
                                    type="date"
                                    isRequied={true}
                                    onChangeInput={(e) => {
                                       
                                        let value = e.trim();
                                        if (!formDataValidation['dateofbirdth']) {
                                            setFormDataValidation({
                                                ...formDataValidation,
                                                ...{ dateofbirdth: true },
                                            });
                                        }
                                        if (/^[0-9]{4}-[0-9]{2}-[0-9]{2}/.test(value)) {
                                            setFormData({
                                                ...formData,
                                                ...{ dateofbirdth: value },
                                            });
                                        } else {
                                            setFormDataValidation({
                                                ...formDataValidation,
                                                ...{ dateofbirdth: false },
                                            });
                                            setFormData({
                                                ...formData,
                                                ...{ dateofbirdth: "" },
                                            });
                                        }
                                    }}
                                    title="Data urodzenia"
                                ></CustomInput> */}
                                {/* <div className="row_input">
                                    <CustomInput
                                        validation={formDataValidation['street']}
                                        showCalendary={() => {
                                            if (!formDataValidation['street']) {
                                                setFormDataValidation({
                                                    ...formDataValidation,
                                                    ...{ street: true },
                                                });
                                            }
                                        }}
                                        size="small"
                                        isRequied={true}
                                        title="Ulica"
                                        onChangeInput={(e) => {
                                            let value = e.trim();
                                            if (value.length != 0) {
                                                if (!formDataValidation['street']) {
                                                    setFormDataValidation({
                                                        ...formDataValidation,
                                                        ...{ street: true },
                                                    });
                                                }
                                                setFormData({
                                                    ...formData,
                                                    ...{ street: value },
                                                });
                                            } else {
                                                setFormDataValidation({
                                                    ...formDataValidation,
                                                    ...{ street: false },
                                                });
                                                setFormData({
                                                    ...formData,
                                                    ...{ street: "" },
                                                });
                                            }
                                        }}
                                    ></CustomInput>
                                    <CustomInput
                                        validation={formDataValidation['building']}
                                        showCalendary={() => {
                                            if (!formDataValidation['building']) {
                                                setFormDataValidation({
                                                    ...formDataValidation,
                                                    ...{ building: true },
                                                });
                                            }
                                        }}
                                        size="small"
                                        pattern="/"
                                        isRequied={true}
                                        title="Nr domu/mieszkania"
                                        onChangeInput={(e) => {
                                            let building = e.split('/')[0];
                                            let flat =
                                                e.split('/')[1] == undefined ? '' : e.split('/')[1];

                                            let value = building;
                                            if (value.length != 0) {
                                                if (!formDataValidation['building']) {
                                                    setFormDataValidation({
                                                        ...formDataValidation,
                                                        ...{ building: true },
                                                    });
                                                }
                                                setFormData({
                                                    ...formData,
                                                    ...{ building: parseInt(value), flat: flat },
                                                });
                                            } else {
                                                setFormDataValidation({
                                                    ...formDataValidation,
                                                    ...{ building: false },
                                                });
                                                setFormData({
                                                    ...formData,
                                                    ...{ building:"", flat: "" },
                                                });
                                            }
                                        }}
                                    ></CustomInput>
                                </div> */}
                                {/* <div className="row_input">
                                    <CustomInput
                                        validation={formDataValidation['postalCode']}
                                        showCalendary={() => {
                                            if (!formDataValidation['postalCode']) {
                                                setFormDataValidation({
                                                    ...formDataValidation,
                                                    ...{ postalCode: true },
                                                });
                                            }
                                        }}
                                        size="small"
                                        isRequied={true}
                                        title="Kod pocztowy"
                                        onChangeInput={(e) => {
                                            ///^[0-9]{2}-[0-9]{3}/.test(value)
                                            setFormData({
                                                ...formData,
                                                ...{ postalCode: e },
                                            });
                                            let value = e.trim();
                                            if (/^[0-9]{2}-[0-9]{3}/.test(value)) {
                                                if (!formDataValidation['postalCode']) {
                                                    setFormDataValidation({
                                                        ...formDataValidation,
                                                        ...{ postalCode: true },
                                                    });
                                                }
                                                setFormData({
                                                    ...formData,
                                                    ...{ postalCode: value },
                                                });
                                            } else {
                                                setFormDataValidation({
                                                    ...formDataValidation,
                                                    ...{ postalCode: false },
                                                });
                                                setFormData({
                                                    ...formData,
                                                    ...{ postalCode: "" },
                                                });
                                            }
                                        }}
                                    ></CustomInput>
                                    <CustomInput
                                        validation={formDataValidation['city']}
                                        showCalendary={() => {
                                            if (!formDataValidation['city']) {
                                                setFormDataValidation({
                                                    ...formDataValidation,
                                                    ...{ city: true },
                                                });
                                            }
                                        }}
                                        size="small"
                                        isRequied={true}
                                        title="Miejscowość"
                                        onChangeInput={(e) => {
                                            let value = e.trim();
                                            if (value.length != 0) {
                                                if (!formDataValidation['city']) {
                                                    setFormDataValidation({
                                                        ...formDataValidation,
                                                        ...{ city: true },
                                                    });
                                                }
                                                setFormData({
                                                    ...formData,
                                                    ...{ city: value },
                                                });
                                            } else {
                                                setFormDataValidation({
                                                    ...formDataValidation,
                                                    ...{ city: false },
                                                });
                                                setFormData({
                                                    ...formData,
                                                    ...{ city: "" },
                                                });
                                            }
                                        }}
                                    ></CustomInput>
                                </div> */}
                                <CustomInput
                                    validation={formDataValidation['phone']}
                                    showCalendary={() => {
                                        if (!formDataValidation['phone']) {
                                            setFormDataValidation({
                                                ...formDataValidation,
                                                ...{ phone: true },
                                            });
                                        }
                                    }}
                                    isRequied={true}
                                    title="Telefon"
                                    onChangeInput={(e) => {
                                        let value = e.replaceAll(' ', '');
                                        if (/^\d+$/.test(value) && value.length == 9) {
                                            if (!formDataValidation['phone']) {
                                                setFormDataValidation({
                                                    ...formDataValidation,
                                                    ...{ phone: true },
                                                });
                                            }
                                            setFormData({
                                                ...formData,
                                                ...{ phone: parseInt(value) },
                                            });
                                        } else {
                                            setFormDataValidation({
                                                ...formDataValidation,
                                                ...{ phone: false },
                                            });
                                            setFormData({
                                                ...formData,
                                                ...{ phone: "" },
                                            });
                                        }
                                    }}
                                ></CustomInput>
                               <div className="chooseConection">
                    <p>Czy jesteś osobą pełnoletnią?</p>
                    <ChooseUserOption
                        isChekcked={formData.isAdult}
                        onCheck={(e) => {
                            setFormData({...formData, ...{isAdult: true}})
                        }}
                        label="Tak"
                    ></ChooseUserOption>
                    <ChooseUserOption
                        isChekcked={!formData.isAdult}
                        onCheck={(e) => {
                            setFormData({...formData, ...{isAdult: false}})
                        }}
                        label="Nie"
                    ></ChooseUserOption>
                </div>
                            {/* </div> */}
                            <div className="button_section margin20">
                                <CustomButtons
                                    clickFunction={register}
                                    classButton="solid"
                                    size="big"
                                >
                                    ZAŁÓŻ KONTO
                                </CustomButtons>
                                <p>lub</p>
                                <CustomButtons
                                    clickFunction={backToLogin}
                                    classButton="outline"
                                    size="big"
                                >
                                    ZALOGUJ SIĘ
                                </CustomButtons>
                            </div>
                        </div>
                    ) : (
                        ''
                    )}
                    {part.number == 2 ? (
                        <div className="columnLogin_wrapper">
                            <div className="tittle_wraper">
                                <p className="tittle_register">{part.tittle}</p>
                                <p className="conent_register">{part.msg}</p>
                            </div>
                        </div>
                    ) : (
                        ''
                    )}
                    {part.number == 3 ? (
                        <div className="columnLogin_wrapper">
                            <div className="tittle_wraper">
                                <p className="tittle_register">{part.tittle}</p>
                                <p className="conent_register">{part.msg}</p>
                            </div>
                            <div className={part.tittle != 'Na podane dane został już zarejestrowany użytkownik'?"buttonsWraperReg":"singleButtonWraperReg"}>
                                
                            {part.tittle != 'Na podane dane został już zarejestrowany użytkownik'?<CustomButtons
                                    clickFunction={backToLogin}
                                    classButton="solid"
                                    size="big"
                                >
                                    ZALOGUJ SIĘ
                                </CustomButtons>:""}
                                <CustomUnderlineText size="big" clickFunction={changeModal}>
                            Przypomnij hasło
                        </CustomUnderlineText>
                        </div></div>
                    ) : (
                        ''
                    )}
                </div>

                <div className="columDetials">
                    {localStorage.getItem('keyURL') != "" && localStorage.getItem('keyURL') != null? (
                        <div className="columDetials_wrapper">
                            <CustomTittle>Szczegóły zamówienia </CustomTittle>
                            <CourseDetail
                                tittle="login"
                                setHeader={setHeader}
                                header={header}
                            ></CourseDetail>
                        </div>
                    ) : (
                        ''
                    )}
                      
                </div>

             
            </div></div>}
            {/* <div style={{ marginTop: '50px' }}>
                <EDSFooter></EDSFooter>
            </div> */}
        </>
    );
};

export default Register;
